import { motion } from 'framer-motion';
import useReducedMotion from '../../hooks/useReducedMotion';

export default function Reveal({ children, delay = 0, y = 24, className, ...rest }) {
  const reduced = useReducedMotion();

  if (reduced) {
    return <div className={className} {...rest}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-10% 0px' }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
